import React from "react";
import { convertUTCDateLocal } from "../../../../../../../utils/convertionFunc";

function CarePlanMedicationTable({ data }) {
  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "w-full"
          } rounded-lg flex justify-center`}
        >
          <table className="w-full overflow-scroll relative">
            <thead className="border rounded-lg">
              <tr className="rounded-md">
                <th>Medication Taken</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Dosage</th>
              </tr>
            </thead>
            <tbody className="text-center py-2">
              {data?.map((item, idx) => (
                <React.Fragment key={item.key || idx}>
                  <tr className="border-b">
                    <td>{item.drugName}</td>
                    <td>{convertUTCDateLocal(item.startCreatedTime)}</td>
                    <td>{convertUTCDateLocal(item.endCreatedTime)}</td>
                    <td>{item.dosage}</td>
                    {/* <td>{item.content}</td> */}
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CarePlanMedicationTable;